import {
  FaUtensils,
  FaGlassMartini,
  FaCoffee,
  FaShoppingBag,
  FaPalette,
  FaMusic,
  FaTree,
  FaTicketAlt,
  FaDumbbell,
  FaHeart,
  FaGraduationCap,
  FaBell,
  FaUsers,
  FaMoon,
  FaStore,
  FaMapMarker,
} from "react-icons/fa"
import { IconMapType } from "../../types"
import placeholderImage from "../../images/placeholder.png"

export const MODES = {
  LIST: "list",
  MAP: "map",
}

export const DEFAULT_ZOOM = 15.5
export const MAX_MARKERS_PER_TYPE = 32

export const PLACE_DEFAULT_IMAGE = placeholderImage

//TODO: Move back to env
export const MAPBOX_TOKEN = "pk.eyJ1Ijoic3RldmVwZXBwbGUiLCJhIjoiTmd4T0wyNCJ9.1-jWg2J5XmFfnBAhyrORmw"

export const DEFAULT_STYLES = {
  LIGHT: "mapbox://styles/mapbox/light-v10",
  DARK: "mapbox://styles/mapbox/dark-v10",
  STREETS: "mapbox://styles/mapbox/streets-v11",
  OUTDOORS: "mapbox://styles/mapbox/outdoors-v11",
  SATELLITE: "mapbox://styles/mapbox/satellite-streets-v11",
}

export const ICON_MAP: IconMapType = {
  default: FaMapMarker,
  food: FaUtensils,
  drink: FaGlassMartini,
  coffee: FaCoffee,
  shopping: FaShoppingBag,
  arts: FaPalette,
  music: FaMusic,
  outdoors: FaTree,
  entertainment: FaTicketAlt,
  fitness: FaDumbbell,
  health: FaHeart,
  education: FaGraduationCap,
  services: FaBell,
  community: FaUsers,
  nightlife: FaMoon,
  culture: FaStore,
}

export const getMapStyle = (theme: string = "default") => {
  switch (theme.toLowerCase()) {
    case "dark":
      return DEFAULT_STYLES.DARK
    case "satellite":
      return DEFAULT_STYLES.SATELLITE
    case "streets":
      return DEFAULT_STYLES.STREETS
    case "light":
    case "default":
    default:
      return DEFAULT_STYLES.LIGHT
  }
}

export const CATEGORY_ICONS: { [key: string]: any } = {
  restaurant: FaUtensils,
  bar: FaGlassMartini,
  coffee: FaCoffee,
  shop: FaShoppingBag,
  art: FaPalette,
  music: FaMusic,
  outdoors: FaTree,
  entertainment: FaTicketAlt,
  fitness: FaDumbbell,
  health: FaHeart,
  education: FaGraduationCap,
  services: FaBell,
  community: FaUsers,
  nightlife: FaMoon,
  retail: FaStore,
  default: FaMapMarker,
}

export const getCategoryIcon = (category: string) => {
  const normalizedCategory = category.toLowerCase().replace(/[^a-z]/g, "")
  return CATEGORY_ICONS[normalizedCategory] || CATEGORY_ICONS.default
}
